// Función principal para reorganizar precios
function reorganizarPrecios() {
  const priceContainer = document.querySelector('.lb-bundle-cta-total-cont .lb-price-vd .lb-price');
  
  if (!priceContainer) return false;
  
  const compareCont = priceContainer.querySelector('.lb-compare-cont');
  const salePrice = priceContainer.querySelector('.lb-price-sale-price');
  const comparePrice = priceContainer.querySelector('.lb-price-compare-price');
  const discount = priceContainer.querySelector('.lb-price-discount');
  
  if (!compareCont || !salePrice || !comparePrice || !discount) return false;
  
  // Verificar si ya está ordenado correctamente
  const yaOrdenado = compareCont.firstChild === salePrice && 
                     compareCont.contains(comparePrice) && 
                     !compareCont.contains(discount);
  
  if (yaOrdenado) {
    // Quitar el símbolo "-" del descuento
    discount.textContent = discount.textContent.replace('-', '');
    return true;
  }
  
  // Reorganizar estructura
  compareCont.innerHTML = '';
  compareCont.appendChild(salePrice);
  compareCont.appendChild(comparePrice);
  priceContainer.insertBefore(discount, compareCont.nextSibling);
  
  // Quitar el símbolo "-" del descuento
  discount.textContent = discount.textContent.replace('-', '');
  
  return true;
}

// Inicialización
let ejecutado = false;

const observer = new MutationObserver(() => {
  if (!ejecutado && reorganizarPrecios()) {
    ejecutado = true;
    observer.disconnect();
  }
});

setTimeout(() => {
  if (!reorganizarPrecios()) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    ejecutado = true;
  }
}, 2000);